/** Styl zaškrtávátka k tématu Erma */
export const CheckboxStyles = {
  borderRadius: 'var(--erma-border-radius-sm)',
  width: '18px',
  height: '18px',
  background: 'var(--erma-secondary-0)',
  checkedBackground: 'var(--erma-primary-700)',
  checkedHoverBackground: 'var(--erma-primary-500)',
  disabledBackground: 'var(--erma-secondary-40)',
  filledBackground: 'var(--erma-primary-0)',
  borderColor: 'var(--erma-secondary-220)',
  hoverBorderColor: 'var(--erma-secondary-300)',
  focusBorderColor: 'var(--erma-primary-400)',
  checkedBorderColor: 'var(--erma-primary-500)',
  checkedHoverBorderColor: 'var(--erma-primary-300)',
  checkedFocusBorderColor: 'var(--erma-primary-400)',
  checkedDisabledBorderColor: 'var(--erma-primary-50)',
  invalidBorderColor: '#a94442',
  icon: {
    size: '0.875rem',
    color: 'var(--erma-primary-900)',
    checked: {
      color: 'var(--erma-primary-0)',
      hoverColor: 'var(--erma-primary-0)'
    }
  }
};
